import { useCallback, useState } from 'react'

export type PopoverHandlers<T extends HTMLElement = HTMLElement> = {
  anchorEl: T | null
  open: boolean
  handleOpen: (event: React.MouseEvent<T> | null) => void
  handleClose: () => void
  toggle: (event: React.MouseEvent<T> | null) => void
  setAnchorEl: (value: T | null) => void
}

export function usePopover<T extends HTMLElement = HTMLElement>(): PopoverHandlers<T> {
  const [anchorEl, setAnchorEl] = useState<T | null>(null)

  const handleOpen = useCallback((event: React.MouseEvent<T> | null) => {
    setAnchorEl(event?.currentTarget ?? null)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const toggle = useCallback(
    (event: React.MouseEvent<T> | null) => {
      if (anchorEl) {
        setAnchorEl(null)
      } else {
        setAnchorEl(event?.currentTarget ?? null)
      }
    },
    [anchorEl],
  )

  const open = Boolean(anchorEl)

  return { anchorEl, open, handleOpen, handleClose, toggle, setAnchorEl }
}
